import React from 'react';
import { IServiceArticle } from 'types/types';
import s from './ServiceArticlesList.module.scss';
import ServiceArticlesItem from './ServiceArticlesItem/ServiceArticlesItem';
import { useTranslation } from 'react-i18next';

interface Props {
    articles: IServiceArticle[];
    showBlogButton?: boolean;
}

const ServiceArticlesList = ({ articles, showBlogButton = false }: Props) => {
    const { t } = useTranslation('ServicePage');
    return (
        <div className={s.container}>
            <div className={s.heading}>{t('serviceArticlesTitle')}</div>
            <ul className={s.list}>
                {articles.length === 0 && <li className={s.noNews}>{t('noNewNewsText')}</li>}
                {articles.map((article: IServiceArticle) => (
                    <ServiceArticlesItem article={article} key={article.id} />
                ))}
            </ul>
        </div>
    );
};

export default ServiceArticlesList;
